import { styled } from "@mui/material/styles";
import { Drawer, FormControlLabel, Stack, Typography } from "@mui/material";
import { HubButton } from "../../components";

export const StyledDrawer = styled(Drawer)({
  "& .MuiDrawer-paper": {
    width: "100%",
    maxWidth: "550px",
    // borderRadius: "0px 25px 25px 0",
    overflow: "hidden",
  },
});

export const StyledSideBar = styled(Stack)(({ theme }) => ({
  alignItems: "center",
  borderRight: "1px solid",
  maxWidth: "350px",
  width: "100%",
  borderColor: theme.palette.hubColors.greyLight,
  backgroundColor: theme.palette.hubColors.greyLightest,
  overflowY: "auto",
  "::-webkit-scrollbar": {
    display: "none",
  },
}));

export const StyledTitleStack = styled(Stack)(({ theme }) => ({
  width: "100%",
  alignItems: "center",
  gap: "16px",
  padding: "36px 40px 28px",
  borderBottom: "1px solid",
  borderColor: theme.palette.hubColors.greyLight,
  textAlign: "center",
  background: `linear-gradient(160deg, ${theme.palette.hubColors.mainFocusLightest} 0%, ${theme.palette.hubColors.white} 70%)`,
}));

export const StyledAvatar = styled(Stack)(({ theme }) => ({
  width: "72px",
  height: "72px",
  borderRadius: "50%",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: theme.palette.hubColors.mainFocus,
  color: theme.palette.hubColors.fontWhite,
  fontSize: "26px",
  fontWeight: 700,
  letterSpacing: "1px",
  boxShadow: `0 4px 14px ${theme.palette.hubColors.mainFocusLight}`,
  flexShrink: 0,
}));

export const StyledAddressStack = styled(Stack)(() => ({
  width: "100%",
  gap: "20px",
  padding: "24px",
}));

export const StyledAddressCard = styled(Stack)(({ theme }) => ({
  width: "100%",
  gap: "16px",
  padding: "16px",
  borderRadius: "10px",
  border: "1px solid",
  borderColor: theme.palette.hubColors.greyLight,
  backgroundColor: theme.palette.hubColors.white,
  boxSizing: "border-box",
}));

export const StyledSectionDivider = styled(Stack)(({ theme }) => ({
  flexDirection: "row",
  alignItems: "center",
  gap: "10px",
  "& hr": {
    flex: 1,
    border: "none",
    borderTop: `1px solid ${theme.palette.hubColors.greyLight}`,
  },
}));

export const StyledContactButton = styled(HubButton)(({ theme }) => ({
  padding: "12px",
  gap: "8px",
  width: "42px",
  height: "42px",
  borderRadius: "25px",
  minWidth: 0,
  boxShadow: `0 2px 8px ${theme.palette.hubColors.greyMidTransparent}`,
  "&:hover": {
    transform: "translateY(-1px)",
    boxShadow: `0 4px 12px ${theme.palette.hubColors.mainFocusLighter}`,
  },
  transition: "transform 0.15s ease, box-shadow 0.15s ease",
}));

export const StyledEditButton = styled(HubButton)(() => ({
  padding: "6px 16px",
  width: "fit-content",
  height: "37px",
  minWidth: 0,
}));

export const StyledDetailStack = styled(Stack)({
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  alignItems: "start",
  justifyContent: "center",
  columnGap: "25px",
  rowGap: "15px",
});

export const StyledFormControlLabel = styled(FormControlLabel)(({ theme }) => ({
  justifyContent: "start",
  margin: 0,
  gap: "7px",
  "& .MuiCheckbox-root, .Mui-disabled": {
    padding: 0,
    color: `${theme.palette.hubColors.mainFocus} !important`,
  },
}));

export const StyledCardContainer = styled(Stack)(({ theme }) => ({
  width: "100%",
  height: "100%",
  minHeight: "fit-content",
  //   overflow: "auto",
  //   maxHeight: "max-content",
  padding: "25px",
  gap: "25px",
  borderRadius: "10px",
  border: "1px solid",
  borderColor: theme.palette.hubColors.greyLight,
  backgroundColor: theme.palette.hubColors.white,
  boxSizing: "border-box",
  "> .MuiStack-root": {
    // overflow: "auto",
  },
  "& .MuiTableContainer-root": {
    // overflow: "auto",
  },
}));

export const StyledCard = styled(Stack)(({ theme }) => ({
  padding: "25px",
  gap: "5px",
  borderRadius: "10px",
  border: "1px solid",
  borderColor: theme.palette.hubColors.greyLight,
  backgroundColor: theme.palette.hubColors.white,
  boxSizing: "border-box",
  flexGrow: 1,
}));

export const StyledDataStack = styled(Stack)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(4, 1fr)",
  gap: "10px",
  [theme.breakpoints.down("lg")]: {
    gridTemplateColumns: "repeat(2, 1fr)",
  },
  [theme.breakpoints.down("md")]: {
    gridTemplateColumns: "repeat(1, 1fr)",
  },
}));

export const StyledPercentStack = styled(Stack, {
  shouldForwardProp: (prop) => !["color"].includes(prop),
})(({ theme, color }) => ({
  flexDirection: "row",
  gap: "5px",
  alignItems: "center",
  color: theme.palette.hubColors[color],
}));

export const StyledPercentText = styled(Typography, {
  shouldForwardProp: (prop) => !["color", "heavy"].includes(prop),
})(({ theme, color, heavy }) => ({
  fontSize: 11,
  color: theme.palette.hubColors[color],
  fontWeight: heavy ? 600 : 300,
}));
